export const SCHEDULE = 'schedule';

export const RECURRENCE = 'recurrence';
export const REST_DAY_AFTER_ACTION = 'delayAfterActionTaken';
export const REST_DAY_CROSS_RULE = 'entityRestingPeriod';
export const EVERY = 'intervalHours';
export const AT_TIME = 'runAtTime';
export const DAYS = 'repeatDays';
export const ON_DATE = 'runOnceDate';

export const DAY = 'EveryDay';
export const WEEK = 'EveryWeek';
export const HOURS = 'IntervalHours';
export const ONCE = 'Once';

export const DAYS_LIST = [
  {
    id: 'Sun',
    name: 'Sunday',
  },
  {
    id: 'Mon',
    name: 'Monday',
  },
  {
    id: 'Tue',
    name: 'Tuesday',
  },
  {
    id: 'Wed',
    name: 'Wednesday',
  },
  {
    id: 'Thu',
    name: 'Thursday',
  },
  {
    id: 'Fri',
    name: 'Friday',
  },
  {
    id: 'Sat',
    name: 'Saturday',
  },
];

export const numberWithZero = (i) => {
  return `${i.toString().padStart(2, '0')}`;
};
